module.exports = __webpack_public_path__ + "gb-sct.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gb-sct.svg
// module id = 905
// module chunks = 0